export const CHECKIN_IDS = {
  programId: 'yiT00XKrrHP',
  stages: {
    checkIn: 'MHG1vCR2pSy',
    objectives: 'VIBtpvkpHFR',
    tasks: 'Nv9nYNcBTdM',
    kra: 'BJb3qTgbcTF',
    kpi: 'ivyCLjNLFrd',
    companyGoals: 'QPDYMPIwsFQ',
    midYearAppraisal: 'xbEyVHbXlGK',
    endYearAppraisal: 'wEsUvf2luKr',
  },
  dataElements: {
    period: 'oBTMhclYzrV',
    date: 'bmqmTAdqugd',
    financialYear: 'pBRXBPly8tU',
    quarter: 'ekqtbvsyKP4',
    objectiveId: 'l5KjyU2yzLb',
    objectiveName: 'ewElxbUnpjZ',
    kra: 'j2vrh0YJjJw',
    kpi: 'LTrCXsLOoDJ',
    taskPpn: 'ruxJB6KwgHf',
    percentComplete: 'DfnMuxUFCJG',
    progressStatus: 'ojep933JPX1',      
    managerComments: 's8yiSCyZNcm',
    employeeComments: 'q8KePlnfq09',
    nextSteps: 'tWmVepJVyv2',
    supportNeeds: 'HyKFc7Wt8W9',
    supportCategory: 'n20bE4SyaRd',
    supportPriority: 'HNGaOVIckQe',
    supportProvided: 'TTbxg1doj9F',
    supportNotes: 'iiztVu3IYVd',
    overallRating: 'zGidbOVR0aP',
    summaryNotes: 'CUqQD1Vb9G2',
    actionItems: 'GI33SWiWxRK',
    keyAchievements: 'ml4qYGRvV5C',
    challenges: 'zua3Lg0kOdr',
    recommendations: 'n4DMZhYmZ5J',
    checkInStatus: 'BiC15JkrX9X',
    meetingDate: 'QG4wiQZRZba',
    meetingNotes: 'bbRChZgeY37',
  },
};

// ✅ Renamed conceptually from Quarter to Check-in Number.
// ⚠️ IMPORTANT: The stored DHIS2 values ('Q1_CHECKIN' / 'Q2_CHECKIN') are
// kept unchanged to preserve compatibility with existing saved check-ins.
export const CHECKIN_PERIODS = {
  FIRST: 'Q1_CHECKIN',
  SECOND: 'Q2_CHECKIN',
};

// Display labels — use these everywhere in the UI
export const CHECKIN_PERIOD_LABELS = {
  [CHECKIN_PERIODS.FIRST]: '1st Check-in',
  [CHECKIN_PERIODS.SECOND]: '2nd Check-in',
};

// Helper for consistent display
export const getCheckInPeriodLabel = (period) =>
  CHECKIN_PERIOD_LABELS[period] || period || '';

// Optional: ordinal-based sub-labels (e.g., "1st Check-in (Month 3)")
// Adjust the parenthetical text to match your scheduling logic.
export const CHECKIN_PERIOD_SUBLABELS = {
  [CHECKIN_PERIODS.FIRST]: '1st Check-in',
  [CHECKIN_PERIODS.SECOND]: '2nd Check-in',
};

export const getCheckInPeriodSubLabel = (period) =>
  CHECKIN_PERIOD_SUBLABELS[period] || getCheckInPeriodLabel(period);


export const CHECKIN_STATUS = {
  NOT_STARTED: 'NOT_STARTED',
  INITIATED: 'INITIATED',
  DRAFT: 'DRAFT',
  SUBMITTED: 'SUBMITTED',
  UNDER_REVIEW: 'UNDER_REVIEW',
  RETURNED: 'RETURNED',
  REVIEWED: 'REVIEWED',
  MEETING_SCHEDULED: 'MEETING_SCHEDULED',
  COMPLETED: 'COMPLETED'
};

export const STATUS_CONFIG = {
  [CHECKIN_STATUS.NOT_STARTED]:      { label: 'Not Started' },
  [CHECKIN_STATUS.INITIATED]:        { label: 'Initiated – Awaiting Staff' },
  [CHECKIN_STATUS.DRAFT]:            { label: 'Draft' },
  [CHECKIN_STATUS.SUBMITTED]:        { label: 'Submitted' },
  [CHECKIN_STATUS.UNDER_REVIEW]:     { label: 'Under Review' },
  [CHECKIN_STATUS.RETURNED]:         { label: 'Returned – Action Needed' },
  [CHECKIN_STATUS.REVIEWED]:         { label: 'Reviewed' },
  [CHECKIN_STATUS.MEETING_SCHEDULED]:{ label: 'Meeting Scheduled' },
  [CHECKIN_STATUS.COMPLETED]:        { label: 'Completed' },
};